import React, {Fragment, useEffect, useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import Api from "../../Api";
import FormatDate from "../Utils/FormatDate";
import VTabBar from "../Utils/VTabBar";
import Amount from "../Utils/Amount";
import Icon from "../Utils/Icon";
import classes from "./styles.module.css";

import card from "./images/card.svg";
import visa from "./images/visa.svg";
import mastercard from "./images/mastercard.svg";
import maestro from "./images/maestro.svg";
import jcb from "./images/jcb.svg";
import mir from "./images/mir.svg";

function TableRow({
                      data,
                      token,
                      onTransactionCancel,
                      cancelTransactionData,
                      cancelInProcess,
                      adminPrivileges,
                  }) {
    const intl = useIntl();
    const [isOpened, setIsOpened] = useState(false);
    const [status, setStatus] = useState(false);
    const [accountingDate, setAccountingDate] = useState(data.accountingDate);
    const [, setInProcessCancel] = useState(false);
    const [checkResult, setCheckResult] = useState(null);
    const [isChecking, setIsChecking] = useState(false);
    const [txType, setTxType] = useState(data.type);
    const [txStatusText, setTxStatusText] = useState(data.status);

    // === NEW: локально отображаемая сумма ===
    const [displayAmount, setDisplayAmount] = useState(data.amount);

    // === NEW: управление изменением суммы ===
    const [editAmount, setEditAmount] = useState(
        data.amount !== undefined && data.amount !== null ? String(data.amount) : ""
    );
    const [isAmountSaving, setIsAmountSaving] = useState(false);

    // Повторная отправка мерчанту. Для депозита агента это повтор зачисления.
    const isAgentDeposit = data.isAgentDeposit === true;
    const [isResending, setIsResending] = useState(false);

    useEffect(() => {
        if (cancelInProcess.id === data.id) {
            setInProcessCancel(cancelInProcess.inProcess);
        }
    }, [cancelInProcess, data.id]);

    useEffect(() => {
        if (cancelTransactionData.currentId === data.id) {
            new Api({token}).getTransactionStatus(data.id).then((r) => {
                setAccountingDate(r.accountingDate || data.accountingDate);
                setInProcessCancel(false);
                setStatus(r);
            });
        }
    }, [cancelTransactionData, data.id, token]);

    // если раскрыли строку — подставим текущую сумму в инпут
    useEffect(() => {
        if (isOpened) {
            setEditAmount(displayAmount !== undefined && displayAmount !== null ? String(displayAmount) : "");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpened]);

    const styles = {transaction: {color: "#d4d4d4", borderColor: "#d4d4d4"}};

    const cardLogo = (function () {
        switch (data.cardBrand) {
            case "VISA":
                return <img src={visa} width="39" height="18" alt="VISA"/>;
            case "MASTERCARD":
                return <img src={mastercard} width="36" height="20" alt="MASTERCARD"/>;
            case "MAESTRO":
                return <img src={maestro} width="36" height="20" alt="MAESTRO"/>;
            case "NSPK MIR":
                return <img src={mir} width="39" height="20" alt="MIR"/>;
            case "JCB":
                return <img src={jcb} width="39" height="20" alt="JCB"/>;
            case "DINERS CLUB INTERNATIONAL":
                return <Icon className={classes.CardIcon} icon="cc-diners-club" size="22px"/>;
            case "AMERICAN EXPRESS":
                return <Icon className={classes.CardIcon} icon="americanexpress" size="18px"/>;
            case "CHINA UNION PAY":
                return <Icon className={classes.CardIcon} icon="americanexpress" size="18px"/>;
            case "DISCOVER":
                return <Icon className={classes.CardIcon} icon="discover" size="18px"/>;
            default:
                return <img src={card} width="28" height="20" alt="CARD"/>;
        }
    })();

    const updateStyle = () => {
        const successColor = "#109618";  // зелёный — успешные
        const declineColor = "#DC3912";  // красный — ошибки
        const createdColor = "#000000";  // чёрный — созданные/pending

        const map = {
            // Успешные — зелёные
            purchase: successColor,
            recurrent: successColor,
            reversal: successColor,
            refund: successColor,
            payout: successColor,
            sbp: successColor,
            mP2P: successColor,
            successfulP2P: successColor,
            successfulSBP: successColor,
            mobilePayout: successColor,
            qr: successColor,
            chargeback: "#644f0b",

            // Decline — красные
            payoutDecline: declineColor,
            purchaseDecline: declineColor,
            refundDecline: declineColor,
            reversalDecline: declineColor,
            recurrentDecline: declineColor,
            mP2PDecline: declineColor,
            sbpDecline: declineColor,
            mobilePayoutDecline: declineColor,
            qrDecline: declineColor,

            // Created / Pending — чёрные
            created: createdColor,
            payoutCreated: createdColor,
            purchaseCreated: createdColor,
            refundCreated: createdColor,
            reversalCreated: createdColor,
            recurrentCreated: createdColor,
            mP2PCreated: createdColor,
            sbpCreated: createdColor,
            mobilePayoutCreated: createdColor,
            qrCreated: createdColor,
            payoutPending: createdColor,
            purchasePending: createdColor,
            refundPending: createdColor,
            reversalPending: createdColor,
            recurrentPending: createdColor,
            mP2PPending: createdColor,
            sbpPending: createdColor,
            mobilePayoutPending: createdColor,
            threeDSPending: createdColor,
            qrPending: createdColor,
        };
        const color = map[txType] || createdColor;
        styles.transaction = {color, borderColor: color};
    };
    updateStyle();

    function toggleOpened(e) {
        e.stopPropagation();
        setIsOpened((prev) => !prev);
        if (!status && (txType === "purchase" || txType === "recurrent")) {
            new Api({token}).getTransactionStatus(data.id).then(setStatus);
        }
    }

    const isPendingOrCreated = (type) =>
        typeof type === "string" &&
        (type.indexOf("Pending") !== -1 || type.indexOf("Created") !== -1 || type === "created");

    function toDeclineType(type) {
        if (!type || typeof type !== "string") return type;
        if (type.indexOf("Pending") !== -1) return type.replace("Pending", "Decline");
        if (type.indexOf("Created") !== -1) return type.replace("Created", "Decline");
        if (type === "created") return "purchaseDecline";
        return type;
    }

    async function handleDeclineClick(e) {
        e.preventDefault();
        e.stopPropagation();
        if (
            !window.confirm(
                intl.formatMessage(
                    {
                        id: "TransactionsTable.confirm.decline",
                        defaultMessage: "Перевести транзакцию {id} в статус Decline?",
                    },
                    {id: data.id}
                )
            )
        ) return;

        try {
            await new Api({token}).declineTransaction(data.id);
            const newType = toDeclineType(txType);
            setTxType(newType);
            setTxStatusText("decline");
            alert(
                intl.formatMessage({
                    id: "TransactionsTable.success.decline",
                    defaultMessage: "Статус транзакции обновлён на Decline",
                })
            );
        } catch (err) {
            alert(
                intl.formatMessage({
                    id: "TransactionsTable.error.decline",
                    defaultMessage: "Не удалось перевести транзакцию в статус Decline",
                })
            );
        }
    }

    function toPayoutType(type) {
        if (!type || typeof type !== "string") return type;
        if (type.indexOf("Pending") !== -1) return "payoutPending";
        if (type.indexOf("Created") !== -1) return "payoutCreated";
        if (type === "created") return "payoutCreated";
        return "payout";
    }

    async function handlePayoutClick(e) {
        e.preventDefault();
        e.stopPropagation();
        if (
            !window.confirm(
                intl.formatMessage(
                    {
                        id: "TransactionsTable.confirm.payout",
                        defaultMessage: "Перевести транзакцию {id} в статус Payout?",
                    },
                    {id: data.id}
                )
            )
        ) return;

        try {
            await new Api({token}).payoutTransaction(data.id);
            const newType = toPayoutType(txType);
            setTxType(newType);
            setTxStatusText("payout");
            alert(
                intl.formatMessage({
                    id: "TransactionsTable.success.payout",
                    defaultMessage: "Статус транзакции обновлён на Payout",
                })
            );
        } catch (err) {
            alert(
                intl.formatMessage({
                    id: "TransactionsTable.error.payout",
                    defaultMessage: "Не удалось перевести транзакцию в статус Payout",
                })
            );
        }
    }

    // === Повторная отправка мерчанту ===
    const resendFlowLabel = (flow) =>
        intl.formatMessage({
            id: `TransactionsTable.resend.flow.${flow}`,
            defaultMessage: flow || "—",
        });

    function resendResultText(res) {
        const lines = [res.message || ""];
        lines.push(
            intl.formatMessage(
                {id: "TransactionsTable.resend.result.flow", defaultMessage: "Формат: {flow}"},
                {flow: resendFlowLabel(res.flow)}
            )
        );
        if (res.urlHost) {
            lines.push(
                intl.formatMessage(
                    {id: "TransactionsTable.resend.result.host", defaultMessage: "Адрес: {host}"},
                    {host: res.urlHost}
                )
            );
        }
        if (res.httpCode !== undefined && res.httpCode !== null) {
            lines.push(
                intl.formatMessage(
                    {id: "TransactionsTable.resend.result.httpCode", defaultMessage: "Ответ мерчанта: HTTP {code}"},
                    {code: res.httpCode}
                )
            );
        }
        return lines.filter(Boolean).join("\n");
    }

    function resendErrorText(err) {
        const body = err && err.response && err.response.data;
        return (
            (body && body.message) ||
            intl.formatMessage({
                id: "TransactionsTable.resend.error",
                defaultMessage: "Не удалось отправить мерчанту повторно",
            })
        );
    }

    // Депозит агента после повтора мог сменить статус (зачислен / снова отказ).
    function applyDepositStatus(res) {
        const map = {success: "purchase", declined: "purchaseDecline", processing: "purchasePending"};
        if (res && res.depositStatus && map[res.depositStatus]) {
            setTxType(map[res.depositStatus]);
        }
    }

    async function handleResendClick(e) {
        e.preventDefault();
        e.stopPropagation();
        if (
            !window.confirm(
                isAgentDeposit
                    ? intl.formatMessage(
                          {
                              id: "TransactionsTable.resend.confirmDeposit",
                              defaultMessage: "Повторить доставку депозита {id} мерчанту?",
                          },
                          {id: data.id}
                      )
                    : intl.formatMessage(
                          {
                              id: "TransactionsTable.resend.confirm",
                              defaultMessage: "Отправить мерчанту уведомление по транзакции {id} повторно?",
                          },
                          {id: data.id}
                      )
            )
        ) return;

        const api = new Api({token});
        setIsResending(true);
        try {
            const res = await api.resendTransactionCallback(data.id);
            applyDepositStatus(res);
            alert(resendResultText(res));
        } catch (err) {
            const status = err && err.response && err.response.status;
            const body = err && err.response && err.response.data;
            if (status === 409 && body && body.needsConfirmation) {
                // Отклонённый депозит: деньги мерчанту — только после отдельного подтверждения.
                const confirmed = window.confirm(
                    intl.formatMessage(
                        {
                            id: "TransactionsTable.resend.confirmReopen",
                            defaultMessage:
                                "Депозит {id} закрыт отказом мерчанта. Он будет отправлен мерчанту заново и, если мерчант его примет, зачислен на баланс мерчанта (сумма за вычетом комиссии). Продолжить?",
                        },
                        {id: data.id}
                    )
                );
                if (confirmed) {
                    try {
                        const res = await api.resendTransactionCallback(data.id, {reopenDeclined: true});
                        applyDepositStatus(res);
                        alert(resendResultText(res));
                    } catch (err2) {
                        alert(resendErrorText(err2));
                    }
                }
            } else {
                alert(resendErrorText(err));
            }
        } finally {
            setIsResending(false);
        }
    }

    // === NEW: изменить сумму ===
    async function handleAmountChangeSave(e) {
        e.preventDefault();
        e.stopPropagation();

        const normalized = String(editAmount || "").trim().replace(",", ".");

        if (!normalized) {
            alert(
                intl.formatMessage({
                    id: "TransactionsTable.amount.error.required",
                    defaultMessage: "Введите сумму",
                })
            );
            return;
        }
        if (!/^\d+(\.\d+)?$/.test(normalized)) {
            alert(
                intl.formatMessage({
                    id: "TransactionsTable.amount.error.invalid",
                    defaultMessage: "Некорректный формат суммы. Пример: 1000 или 1000.50",
                })
            );
            return;
        }

        if (
            !window.confirm(
                intl.formatMessage(
                    {
                        id: "TransactionsTable.amount.confirm",
                        defaultMessage: "Изменить сумму транзакции {id} на {amount}?",
                    },
                    {id: data.id, amount: normalized}
                )
            )
        ) return;

        setIsAmountSaving(true);
        try {
            const res = await new Api({token}).changeTransactionAmount(data.id, normalized);

            if (res && res.error) {
                alert(
                    res.message ||
                        intl.formatMessage({
                            id: "TransactionsTable.amount.error.save",
                            defaultMessage: "Не удалось изменить сумму транзакции",
                        })
                );
                return;
            }

            // сервер вернёт newAmount (major units), используем её
            if (res && res.newAmount !== undefined && res.newAmount !== null) {
                setDisplayAmount(res.newAmount);
                setEditAmount(String(res.newAmount));
            } else {
                // fallback
                setDisplayAmount(Number(normalized));
            }

            alert(
                intl.formatMessage({
                    id: "TransactionsTable.amount.success",
                    defaultMessage: "Сумма транзакции обновлена",
                })
            );
        } catch (err) {
            const msg =
                (err && err.response && err.response.data && err.response.data.message) ||
                intl.formatMessage({
                    id: "TransactionsTable.amount.error.save",
                    defaultMessage: "Не удалось изменить сумму транзакции",
                });
            alert(msg);
        } finally {
            setIsAmountSaving(false);
        }
    }

    const fixServerTime = (date) => {
        if (!date) return null;
        const d = new Date(date);
        return new Date(d.getTime() - 3 * 60 * 60 * 1000);
    };

    return (
        <Fragment>
            <tr onClick={toggleOpened} className={classes.Row}>
                <td>
                    <div>
                        <FormatDate
                            setDate={data.date}
                            format={{
                                day: "numeric",
                                month: "numeric",
                                year: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                            }}
                        />
                    </div>
                    <div style={styles.transaction} className={classes.Status}>
                        <span style={styles.transaction}/>
                        <FormattedMessage id={`TransactionsTable.label.${txType}`} defaultMessage={txType}/>
                    </div>
                </td>

                <td>
                    {data.firstPart} •••• {data.lastPart}
                    <br/>
                    {cardLogo}
                </td>

                <td>
                    <Amount amount={displayAmount} currency={data.currencyCode}/>
                </td>

                <td>{data.merchantName}</td>

                <td>
                    {isOpened ? (
                        <Icon className={classes.Icon} icon="cheveron-up" size="18px"/>
                    ) : (
                        <Icon className={classes.Icon} icon="cheveron-down" size="18px"/>
                    )}
                </td>
            </tr>

            {isOpened && (
                <tr className={classes.InnerRow}>
                    <td colSpan={5} onClick={(e) => e.stopPropagation()}>
                        <div onClick={(e) => e.stopPropagation()}>
                            <VTabBar
                                defaultActiveTab={intl.formatMessage({
                                    id: "TransactionsTable.tab.paymentData",
                                    defaultMessage: "Данные платежа",
                                })}
                            >
                                <VTabBar.Tab
                                    label={
                                        <FormattedMessage
                                            id="TransactionsTable.tab.paymentData"
                                            defaultMessage="Данные платежа"
                                        />
                                    }
                                    navIcon="align-justified"
                                    isVisible={true}
                                >
                                    <table className={classes.TabTable}>
                                        <tbody>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="TransactionsTable.tab.amount"
                                                    defaultMessage="Сумма:"
                                                />
                                            </td>
                                            <td>
                                                <Amount amount={displayAmount} currency={data.currencyCode}/>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="TransactionsTable.tab.fee"
                                                    defaultMessage="Коммиссия:"
                                                />
                                            </td>
                                            <td>
                                                <Amount amount={data.fee} currency={data.currencyCode}/>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="TransactionsTable.tab.email"
                                                    defaultMessage="Электронная почта:"
                                                />
                                            </td>
                                            <td>{data.customerMail || <span>—</span>}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="TransactionsTable.tab.cardHolder"
                                                    defaultMessage="Держатель карты:"
                                                />
                                            </td>
                                            <td>{data.cardHolder}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="TransactionsTable.tab.phone"
                                                    defaultMessage="Телефон:"
                                                />
                                            </td>
                                            <td>{data.customerPhone || <span>—</span>}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </VTabBar.Tab>

                                <VTabBar.Tab
                                    label={
                                        <FormattedMessage
                                            id="TransactionsTable.tab.parameters"
                                            defaultMessage="Параметры платежа"
                                        />
                                    }
                                    navIcon="file-text"
                                    navIconSize={16}
                                    isVisible={true}
                                >
                                    <table className={classes.TabTable}>
                                        <tbody>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="TransactionsTable.tab.id"
                                                    defaultMessage="Идентификатор операции:"
                                                />
                                            </td>
                                            <td>{data.id}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="TransactionsTable.tab.processId"
                                                    defaultMessage="Идентификатор процесса:"
                                                />
                                            </td>
                                            <td>
                                                {data.processingOrderId
                                                    ? data.processingOrderId.replace(/^(\d+\|)/, "")
                                                    : "—"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="TransactionsTable.tab.extendedStatus"
                                                    defaultMessage="Расширенный статус:"
                                                />
                                            </td>
                                            <td>{txStatusText || <span>—</span>}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="TransactionsTable.tab.processed"
                                                    defaultMessage="Обработан:"
                                                />
                                            </td>
                                            <td>
                                                <FormatDate
                                                    setDate={fixServerTime(accountingDate || data.accountingDate)}
                                                    format={{
                                                        day: "numeric",
                                                        month: "numeric",
                                                        year: "numeric",
                                                        hour: "numeric",
                                                        minute: "numeric",
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="TransactionsTable.tab.bank"
                                                    defaultMessage="Банк карты:"
                                                />
                                            </td>
                                            <td>{data.cardBankName || <span>—</span>}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="TransactionsTable.tab.country"
                                                    defaultMessage="Страна карты:"
                                                />
                                            </td>
                                            <td>
                                                {data.cardBankCountryCode ? (
                                                    <FormattedMessage
                                                        id={`binBase.country.${data.cardBankCountryCode}`}
                                                        defaultMessage={data.cardBankCountryCode}
                                                    />
                                                ) : (
                                                    <span>—</span>
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage id="TransactionsTable.tab.rrn" defaultMessage="RRN:" />
                                            </td>
                                            <td>{data.rrn || <span>—</span>}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </VTabBar.Tab>

                                <VTabBar.Tab
                                    label={
                                        <FormattedMessage
                                            id="TransactionsTable.tab.management"
                                            defaultMessage="Управление"
                                        />
                                    }
                                    navIcon="settings"
                                    navIconSize={16}
                                    isVisible={adminPrivileges}
                                >
                                    <table className={classes.TabTable}>
                                        <tbody>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="TransactionsTable.tab.actions"
                                                    defaultMessage="Операции"
                                                />
                                            </td>
                                            <td>
                                                {!checkResult && (
                                                    <button
                                                        type="button"
                                                        className={classes.LinkBtn}
                                                        onClick={async (e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setIsChecking(true);
                                                            try {
                                                                const result = await new Api({token}).checkTransaction(data.id);
                                                                setCheckResult(result.data);
                                                                } catch (err) {
                                                                    setCheckResult({
                                                                        error: true,
                                                                        message: intl.formatMessage({
                                                                            id: "TransactionsTable.check.error",
                                                                            defaultMessage: "Ошибка при проверке транзакции",
                                                                        })
                                                                    });
                                                                } finally {
                                                                    setIsChecking(false);
                                                                }
                                                        }}
                                                        disabled={isChecking}
                                                    >
                                                            {isChecking ? (
                                                                <FormattedMessage
                                                                    id="TransactionsTable.check.loading"
                                                                    defaultMessage="Проверка..."
                                                                />
                                                            ) : (
                                                                <FormattedMessage
                                                                    id="TransactionsTable.check.button"
                                                                    defaultMessage="Проверить транзакцию"
                                                                />
                                                            )}
                                                        </button>
                                                    )}

                                                {checkResult && (
                                                    <div onClick={(e) => e.stopPropagation()}>
                                                        <p>
                                                            <FormattedMessage
                                                                id="TransactionsTable.check.result"
                                                                defaultMessage="Результат проверки:"
                                                            />
                                                        </p>

                                                        {checkResult && !checkResult.error ? (
                                                            <table className={classes.TabTable}>
                                                                <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <FormattedMessage
                                                                            id="TransactionsTable.check.provider"
                                                                            defaultMessage="Провайдер:"
                                                                        />
                                                                    </td>
                                                                    <td>{checkResult.provider}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <FormattedMessage
                                                                            id="TransactionsTable.check.status"
                                                                            defaultMessage="Статус:"
                                                                        />
                                                                    </td>
                                                                    <td>{checkResult.statusHuman}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <FormattedMessage
                                                                            id="TransactionsTable.check.amount"
                                                                            defaultMessage="Сумма:"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Amount amount={checkResult.amount}
                                                                                currency={checkResult.currency}/>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <FormattedMessage
                                                                            id="TransactionsTable.check.orderId"
                                                                            defaultMessage="Идентификатор заказа:"
                                                                        />
                                                                    </td>
                                                                    <td>{checkResult.orderId}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <FormattedMessage
                                                                            id="TransactionsTable.check.rrn"
                                                                            defaultMessage="RRN:"
                                                                        />
                                                                    </td>
                                                                    <td>{checkResult.rrn || "—"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <FormattedMessage
                                                                            id="TransactionsTable.check.message"
                                                                            defaultMessage="Сообщение:"
                                                                        />
                                                                    </td>
                                                                    <td>{checkResult.message || "—"}</td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        ) : (
                                                            <pre
                                                                className={classes.jsonBlock}>{JSON.stringify(checkResult, null, 2)}</pre>
                                                        )}

                                                        <button
                                                            type="button"
                                                            className={classes.LinkBtn}
                                                            onClick={handleDeclineClick}
                                                            disabled={!isPendingOrCreated(txType)}
                                                        >
                                                            <FormattedMessage
                                                                id="TransactionsTable.check.decline"
                                                                defaultMessage="Перевести в отклонение"
                                                            />
                                                        </button>
                                                        <br/>
                                                        <button
                                                            type="button"
                                                            className={classes.LinkBtn}
                                                            onClick={handlePayoutClick}
                                                            disabled={!isPendingOrCreated(txType)}
                                                        >
                                                            <FormattedMessage
                                                                id="TransactionsTable.check.payout"
                                                                defaultMessage="Перевести в выплату"
                                                            />
                                                        </button>
                                                    </div>
                                                )}

                                                {/* === Повторная отправка мерчанту === */}
                                                <div style={{marginTop: 12}} onClick={(e) => e.stopPropagation()}>
                                                    <button
                                                        type="button"
                                                        className={classes.LinkBtn}
                                                        onClick={handleResendClick}
                                                        disabled={isResending}
                                                    >
                                                        {isResending ? (
                                                            <FormattedMessage
                                                                id="TransactionsTable.resend.sending"
                                                                defaultMessage="Отправка..."
                                                            />
                                                        ) : isAgentDeposit ? (
                                                            <FormattedMessage
                                                                id="TransactionsTable.resend.buttonDeposit"
                                                                defaultMessage="Повторить зачисление"
                                                            />
                                                        ) : (
                                                            <FormattedMessage
                                                                id="TransactionsTable.resend.button"
                                                                defaultMessage="Отправить мерчанту повторно"
                                                            />
                                                        )}
                                                    </button>
                                                </div>

                                                {/* === NEW: Change amount === */}
                                                <div style={{marginTop: 12}} onClick={(e) => e.stopPropagation()}>
                                                    <div style={{marginBottom: 6, fontWeight: 600}}>
                                                        <FormattedMessage
                                                            id="TransactionsTable.amount.section"
                                                            defaultMessage="Изменить сумму"
                                                        />
                                                    </div>

                                                    <div className={classes.AmountEditRow}>
                                                        <input
                                                            type="text"
                                                            value={editAmount}
                                                            onChange={(e) => setEditAmount(e.target.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                            placeholder={intl.formatMessage({
                                                                id: "TransactionsTable.amount.placeholder",
                                                                defaultMessage: "Например: 1000 или 1000.50",
                                                            })}
                                                            className={classes.AmountEditInput}
                                                            disabled={isAmountSaving}
                                                        />

                                                        <button
                                                            type="button"
                                                            className={classes.LinkBtn}
                                                            onClick={handleAmountChangeSave}
                                                            disabled={isAmountSaving}
                                                        >
                                                            {isAmountSaving ? (
                                                                <FormattedMessage
                                                                    id="TransactionsTable.amount.saving"
                                                                    defaultMessage="Сохранение..."
                                                                />
                                                            ) : (
                                                                <FormattedMessage
                                                                    id="TransactionsTable.amount.save"
                                                                    defaultMessage="Сохранить"
                                                                />
                                                            )}
                                                        </button>
                                                    </div>

                                                    <div style={{marginTop: 6, opacity: 0.8, fontSize: 12}}>
                                                        <FormattedMessage
                                                            id="TransactionsTable.amount.note"
                                                            defaultMessage="Введите сумму в рублях, в БД сохраняется в копейках."
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </VTabBar.Tab>
                            </VTabBar>
                        </div>
                    </td>
                </tr>
            )}
        </Fragment>
    );
}

export default TableRow;



// WEBPACK FOOTER //
// ./src/Components/TransactionsTable/TableRow.js